import React from "react";
import styled from "@emotion/styled";

import useQuery from "../../../helpers/useQuery";
import getMobileOS from "../../../helpers/getMobileOperatingSystem";
import { Button } from "../../Button";
import Hero3 from '../../../images/Hero3.png';
import Hero4 from '../../../images/Hero4.png';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 5vh;
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
  width: 70%;
`;

const BattleContainer = styled.div`
    display: flex;
`;

const HeroImage = styled.img`
    width: 40vw;
    height: 40vw;
    object-fit: contain;

    &.flip {
        transform: scaleX(-1);
    }
`;

const HightailGamesTitle = styled.div`
  color: white;
  font-size: 6vw;
  text-transform: uppercase;
  text-align: center;
`;

export const AddFriend = () => {
  const query = useQuery();
  const mobileOS = getMobileOS();

  let appStoreLink = "";
  if (mobileOS === "iOS") {
    appStoreLink =
      "https://apps.apple.com/app/apple-store/id1558786731?pt=121026607&ct=add-friend-system&mt=8";
  } else if (mobileOS === "Android") {
    appStoreLink =
      "https://play.google.com/store/apps/details?id=com.hightailgames.battlerusharena&referrer=utm_source%3Din-app%26utm_medium%3DaddFriend%26utm_term%3Dadd%2520friend%26utm_campaign%3DAdd%2520Friend";
  } else {
    appStoreLink =
      "https://apps.apple.com/app/apple-store/id1558786731?pt=121026607&ct=add-friend-system&mt=8";
  }

  const username = query.get("username");
  return (
    <Container>
      <Content>
          <BattleContainer>
            <HeroImage src={Hero3} />
            <HeroImage src={Hero4} className='flip' />
          </BattleContainer>
        <HightailGamesTitle>Join your friend</HightailGamesTitle>
        <HightailGamesTitle style={{ color: "#e77134" }}>
          {username}
        </HightailGamesTitle>
        <HightailGamesTitle>in the Arena</HightailGamesTitle>

        <Button
          style={{
            width: "35vw",
            fontSize: "4vw",
            boxShadow: "0 5px 5px black",
            padding: 5,
            marginTop: 15
          }}
          href={appStoreLink}
        >
          Install and Play!
        </Button>
      </Content>
    </Container>
  );
};
